import iconSuccess from '../../../images/icon-success.svg';
import iconError from '../../../images/icon-error.svg';
import iconInfo from '../../../images/icon-info.svg';
import iconWarning from '../../../images/icon-warning.svg';
import '../../../css/style.scss';
import React from "react";

export type IconType = 'SUCCESS' | 'ERROR' | 'INFO' | 'WARNING';
type IconProps = {
  type: IconType;
};

const Icon: React.FC<IconProps> = ({ type }: IconProps) => {
  switch (type) {
    case 'SUCCESS':
      return <img src={iconSuccess} className="icon-success" alt=''/>;
    case 'ERROR':
      return <img src={iconError} className="icon-error" alt=''/>;
    case 'INFO':
      return <img src={iconInfo} className="icon-info" alt=''/>;
    case 'WARNING':
      return <img src={iconWarning} className="icon-warning" alt=''/>;
  }
}

export default Icon;